import { load } from "@nextgisweb/jsrealm/i18n/catalog";
load("formbuilder", {"":{"Form":["Форма"],"Select a dataset":["Выберите набор данных"],"Dataset should be in NGFP format.":["Файл должен быть в формате NGFP."]}})